<template>
    <div class="share-container" v-if="isLoaded">
      <!-- <Header :hasMenu="true"></Header> -->
      <Header v-if="!$route.name.includes('VisitorRetention') && !$route.name==='ShareA/B Result'"></Header>
      <div v-if="isLoaded">

        <div class="share-section">
          <slot />
        </div>
      </div>
    </div>
  </template>
  <script>
  import Header from '@/components/Header.vue'
  import SideMenu from '@/layouts/menus/SideMenu.vue'
  import ApplicationMenu from '@/layouts/menus/ApplicationMenu.vue'
  import ReportMenu from '@/layouts/menus/ReportMenu.vue'
  import SettingMenu from '@/layouts/menus/SettingMenu.vue'
  import Footer from '@/components/Footer.vue'
  
  export default {
    data: function () {
    return {
      secretPosition:17,
      tempjwt:'',
      tempWidgetId:0,
      tempCompanyId:0,
      tempModuleName:'',
      tempModuleUniqueId:0,
      checkFlag:false,
      isLoaded:true
    }
    },
    components: {
      Header,
      SideMenu,
      ApplicationMenu,
      ReportMenu,
      SettingMenu,
      Footer,
    },
    mounted(){
      this.isLoaded = false
      if(this.$route.params.encryptedParam){
        this.tempjwt = window.TEMP_JWT
        this.tempWidgetId = window.TEMP_WIDGET_ID
        this.tempCompanyId = window.TEMP_COMPANY_ID
        this.$http.defaults.headers.companyid = this.tempCompanyId
        this.authCheckForShare()
      }      
    },
    beforeMount() { 
    },
    methods:{
      checkNameForModules(name,cmpName){
        if (name === 'Experiment Result') name = 'A/B Result'
        if(name.replace(/^Share/,'') === cmpName.replace(/^Share/,'')){
          return true
        }
        return false
      },
      authCheckForShare(){
        this.isLoaded = false
        this.checkFlag = false
        this.$http.get(process.env.API_ENDPOINT + '/sharePermission/',{
          headers:{
            'widgetid': this.tempWidgetId,
            'companyid': this.tempCompanyId,
            'jwt': this.tempjwt
          }
        }).then(result =>{
          for (let index = 0; index < result.data.length; index++) {
            const element = result.data[index];
            console.log(element)
            if(this.checkNameForModules(element.modules,this.$route.name) && !this.$route.params.key&& !this.$route.params.value){
              if(element.unique_module_id !==0){
                if(Number(this.$route.params.feedbackId) === Number(element.unique_module_id)||  Number(this.$route.params.test_id) === Number(element.unique_module_id) || Number(this.$route.params.id)=== Number(element.unique_module_id) || Number(this.$route.params.pollGroupId)=== Number(element.unique_module_id)){
                  if(element.flag === 1){
                    // alert(3)
                    location.replace('/404')
                  }else{
                    this.checkFlag = true
                    this.tempModuleName = element.modules
                    this.tempModuleUniqueId = element.unique_module_id
                  }
                }
              } else {
                if(element.flag === 1){
                  this.checkFlag = false
                }else{
                  this.checkFlag = true
                  this.tempModuleName = element.modules
                  this.tempModuleUniqueId = element.unique_module_id
                }
              }

            }else if(this.$route.params.key&& this.$route.params.value && this.checkNameForModules(element.modules,this.$route.name) ){
              if(element.flag === 1 && this.$route.params.key === element.event_type && this.$route.params.value === element.event_name){
                location.replace('/404')
              }else{
                this.checkFlag = true
                this.tempModuleName = element.modules
                this.tempModuleUniqueId = element.unique_module_id
              }
            }
          }
        }).then(()=>{
          if(this.checkFlag === false && this.$route.name !== "Experiment" && this.$route.name !== "ShareVisitorMaps" && this.$route.name !== "ShareAcqChannel" && this.$route.name !== "ShareVisitorRetention"){
            location.replace('/404')
          }else{
            this.updateNoc()
            this.isLoaded = true
          }
        })
        .catch((err) => {
          console.log('check share permission')
          console.error(err)
        })
      },
      updateNoc(){
        let data = {
          modules :this.tempModuleName,
          widget_id: this.tempWidgetId,
          unique_module_id: this.tempModuleUniqueId,
          event_type: ((this.$route.name.includes('EventsDetail')) ? this.$route.params.key : ''),
          event_name: ((this.$route.name.includes('EventsDetail')) ? this.$route.params.value : ''),        
        }
        this.$http.post(process.env.API_ENDPOINT + '/updateNumberOfClickShareLink', data, {
          headers:{
            'jwt':this.tempjwt
          }
        })
      }
    },
  }
  </script>
  <style>
    .share-container {
      max-width: 1260px;
      margin-left: auto;
      margin-right: auto;
    }

    .share-section #edit-form{
      padding-top: 20px !important;
    }
  </style>
  


// WEBPACK FOOTER //
// src/layouts/shareLinkAuth.vue